import React, { useState } from "react";
import { Switch } from "@headlessui/react";

const InputSwitch = () => {
  const [enabled, setEnabled] = useState(false);
  return (
    <Switch
      checked={enabled}
      onChange={setEnabled}
      className="group relative flex h-5 w-10 cursor-pointer rounded-full bg-white/15 p-0.5 transition-colors duration-200 ease-in-out focus:outline-none data-[focus]:outline-1 data-[focus]:outline-none data-[checked]:bg-white/70"
    >
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block size-4 translate-x-0 rounded-full bg-white/30 shadow-lg transition duration-200 ease-in-out group-data-[checked]:translate-x-5 group-data-[checked]:bg-primary"
      />
    </Switch>
  );
};

export default InputSwitch;
